import React, { useCallback, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Nav, NavItem, Row, TabContent, Table, TabPane, Tooltip, NavLink } from "reactstrap";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { toast } from "react-toastify";
import DeleteModal from "../../Components/Common/DeleteModal";
import { deleteDriver } from "./_requests";
import { useProfile } from "../../Components/Hooks/UserHooks";

const ViewDriverDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const driverDetails = location.state?.driverDetailsView;
  const { userProfile } = useProfile();
  const [showMore, setShowMore] = useState(false);
  const toggleReadMore = () => setShowMore(!showMore);
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab: string) => setActiveTab(tab);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  console.log("driverDetails", driverDetails)
  const sanitizeHTML = useCallback((html: string) => {
    return html?.replace(/<script[^>]*>([\S\s]*?)<\/script>/gi, "");
  }, []);


  // If no details, redirect back
  if (!driverDetails) {
    navigate("/plan-subscription");
    return null;
  }

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await deleteDriver(id, userProfile?.userId);
      toast.success("Plan deleted successfully");
      setDeleteModal(false);
      navigate("/plan-subscription");
    } catch (err) {
      toast.error("Failed to delete plan");
      setDeleteModal(false);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="View Subscription" pageTitle="Paal Dappa" />

        <Row>
          <Col lg={12}>
            <Card className="shadow-lg border-0 rounded-3 p-4 position-relative">
              <h3 className="text-primary fw-bold">{driverDetails?.name}</h3>
              {/* Edit & Delete Icons */}
          
              <CardBody>
                {/* Tabs */}
                <Nav tabs className="nav-tabs-custom">
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => toggleTab("1")}
                    >
                      Overview
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => toggleTab("2")}
                    >
                      Driver List
                    </NavLink>
                  </NavItem> */}
                </Nav>

                <TabContent activeTab={activeTab} className="mt-4">
                  {/* Overview Tab */}
                  <TabPane tabId="1">
                    <Row className="gx-lg-5">
                      <Col xl={4}>
                        {driverDetails?.profile && (
                          <div>
                            <img
                              src={driverDetails?.profile}
                              alt={driverDetails?.profile}
                              width={150}
                              height={100}
                              className="rounded mt-2"
                              style={{ cursor: "zoom-in" }}
                            />
                          </div>
                        )}
                      </Col>
                      <Col xl={8}>
                        <Card className="border-1 shadow-sm rounded p-3 bg-light mt-3">
                          <h5 className="text-secondary">Driver Details:</h5>
                          <div className="table-responsive">
                            <Table striped bordered className="bg-white rounded">
                              <thead className="table-light">
                                <tr>
                                  <th>#</th>
                                  <th>Name</th>
                                  <th>Phone No</th>
                                  <th>Email</th>
                                </tr>
                              </thead>
                              <tbody>
                                {driverDetails ? (
                                  <tr>
                                    <td>1</td>
                                    <td>{driverDetails.name || "N/A"}</td>
                                    <td>{driverDetails.contact_number || "N/A"}</td>
                                    <td>{driverDetails.email || "N/A"}</td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      No details available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </Card>
                      </Col>



                    </Row>



                  </TabPane>

                  {/* Driver List Tab */}
                  <TabPane tabId="2">

                    {/* <DriverPlanSubscriptionList /> */}
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>

          </Col>
        </Row>
      </Container>
      {/* Delete Confirmation Modal */}
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
        content={
          <>
            Do you want to delete <strong>{driverDetails?.name}</strong>?
          </>
        }
      />
    </div >
  );
};

export default ViewDriverDetails;
